module.exports = __webpack_public_path__ + "img/emoji_02.62d4d4a5.png";